class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));

  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();


    const submenu = this.mainDetailsToggle.querySelector('.header__submenu');
      if (submenu) {
        const submenuHeight = submenu.getBoundingClientRect().height;
        this.closest('header').style.setProperty('--submenu-height', `${submenuHeight}px`);
      }
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.submenu = this.mainDetailsToggle.querySelector('ul.header__submenu');

    // Unregister default click behavior
    this.mainDetailsToggle.removeEventListener('click', this.onToggle.bind(this));
    
    // Add hover event listeners
    if (this.summary) {
      this.summary.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.submenu.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
  }

  onMouseEnter(e) {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary.setAttribute('aria-expanded', true);
      this.onToggle(e,true);
    }
  }

  onMouseLeave() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.close();
    }
  }

  close() {
    if (this.submenu) {
      // Animate out then remove open attribute
      this.submenu.classList.add('animate-out');
      setTimeout(() => {
        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        this.submenu.classList.remove('animate-out');
      }, 150);
    } else {
      // Fallback to immediate close if no submenu
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
    }
  }

  onToggle(e, open = !this.mainDetailsToggle.hasAttribute('open')) {
    if (!this.header) return;
    

    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);

    const submenu = this.mainDetailsToggle.querySelector('ul.header__submenu');
    if (submenu) {
      const submenuHeight = submenu.getBoundingClientRect().height;
      this.header.style.setProperty('--submenu-height', `${submenuHeight}px`);
      
      // Handle animations for opening/closing
      if (!open) {

        e.preventDefault();
        console.log('Preventing default action for submenu toggle');
        // Prevent immediate close and animate out
        // Animate the submenu with css
        submenu.classList.add('animate-out');
        setTimeout(() => {
            this.close();
          submenu.classList.remove('animate-out');
        }, 150);
      
      }
    }
  }
}

customElements.define('header-menu', HeaderMenu);
